import { IUsersRepository } from '@/domain/repositories/create-user.repository.interface';
import { IExampleRepository } from '@/domain/repositories/example.repository.interface';
import { ICountriesRepository } from '@/domain/repositories/get-countries.repository.interface';
import { IStatesRepository } from '@/domain/repositories/get-states.repository.interface';
import { ILeaguesRepository } from '@/domain/repositories/leagues.repository.interface';
import { ILookupRepository } from '@/domain/repositories/lookup.repository.interface';
import { IMatchesRepository } from '@/domain/repositories/matches.repository.interface';
import { IPlayerRepository } from '@/domain/repositories/player.repository.interface';
import { IScheduleRepository } from '@/domain/repositories/schedule.repository.interface';
import { ITeamLeagueRepository } from '@/domain/repositories/team-league.repository.interface';
import { ITeamLeaguePlayersRepository } from '@/domain/repositories/team-leagues-players.repository.interface';
import { ITeamLeagueTeamsRepository } from '@/domain/repositories/team-leagues-teams.repository.interface';
import { ISystemLocationsRepository } from '@/domain/repositories/system-locations/system-locations.repository.interface';

export const DI_SYMBOLS = {
	IPlayerRepository: Symbol.for('IPlayerRepository'),
	IScheduleRepository: Symbol.for('IScheduleRepository'),
	ILeaguesRepository: Symbol.for('ILeaguesRepository'),
	IMatchesRepository: Symbol.for('IMatchesRepository'),
	ITeamLeagueRepository: Symbol.for('ITeamLeagueRepository'),
	IExampleRepository: Symbol.for('IExampleRepository'),
	ITeamLeaguePlayersRepository: Symbol.for('ITeamLeaguePlayersRepository'),
	ITeamLeagueTeamsRepository: Symbol.for('ITeamLeagueTeamsRepository'),
	IStatesRepository: Symbol.for('IStatesRepository'),
	ICountriesRepository: Symbol.for('ICountriesRepository'),
	IUsersRepository: Symbol.for('IUsersRepository'),
	ILookupRepository: Symbol.for('ILookupRepository'),
	ISystemLocationsRepository: Symbol.for('ISystemLocationsRepository')
};

export interface DI_RETURN_TYPES {
	IPlayerRepository: IPlayerRepository;
	IExampleRepository: IExampleRepository;
	ITeamLeagueRepository: ITeamLeagueRepository;
	IScheduleRepository: IScheduleRepository;
	ILeaguesRepository: ILeaguesRepository;
	IMatchesRepository: IMatchesRepository;
	ITeamLeaguePlayersRepository: ITeamLeaguePlayersRepository;
	ITeamLeagueTeamsRepository: ITeamLeagueTeamsRepository;
	IStatesRepository: IStatesRepository;
	ICountriesRepository: ICountriesRepository;
	IUsersRepository: IUsersRepository;
	ILookupRepository: ILookupRepository;
	ISystemLocationsRepository: ISystemLocationsRepository;
}
